import React from 'react';
import moment from "moment";
import BaseDynamicAPITable from "./BaseDynamicAPITable";
import { useWindowWidth } from '@/hooks/useWindowWidth';
import { priceView } from '@/utils/utils';

export default function RecurringPaymentsTable({ pageSize, filters, delayLoading }) {
    return (
        <BaseDynamicAPITable
            apiMethod="/project/recurringPayments"
            filters={filters}
            pageSize={pageSize}
            delayLoading={delayLoading}
            dataModel={{
                columns: [
                    {
                        header: "Amount",
                        align: "right",
                        render: row => <div className="font-semibold truncate">{priceView(row.amount, row.currency)}</div>,
                        width: useWindowWidth() > 1600 ? 8 : 12,
                        hideHeaderMobile: true,
                    }, {
                        header: "",
                        align: "left",
                        render: row => <span className="font-semibold text-[#A5A5A5] uppercase">{row.currency === 'XTR' ? '⭐' : row.currency}</span>,
                        width: 10,
                        hideHeaderMobile: true,
                    }, {
                        header: "Plan",
                        align: "left",
                        render: row => row.planName
                    }, {
                        header: "Customer",
                        align: "left",
                        render: row => row.fullName
                    }, {
                        header: "Method",
                        align: "left",
                        render: row => <span className="capitalize">{row.method}</span>
                    }, {
                        header: "Received",
                        align: "left",
                        render: row => moment(row.receivedAt).format("lll")
                    }
                ]
            }}
            rowLinkTo={(row) => '/sales/recurringPayment/' + row.recurringPaymentId}
            rowLinkState={(row) => row}
        />
    );

}
